import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../../services/authService';
import Input from '../../components/ui/Input';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setError('');

    // Validation
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password?.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    try {
      const { error: updateError } = await authService?.updatePassword(password);
      
      if (updateError) {
        setError(updateError?.message || 'Failed to update password');
        setLoading(false);
        return;
      }

      setSuccess(true);
      setTimeout(() => {
        navigate('/signin');
      }, 2000);
    } catch (err) {
      setError('An unexpected error occurred');
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center px-4">
        <div className="bg-success text-success-foreground rounded-lg p-8 text-center max-w-md">
          <div className="w-16 h-16 bg-success-foreground text-success rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="CheckCircle" size={32} />
          </div>
          <h2 className="font-headline font-bold text-2xl mb-2">Password Updated!</h2>
          <p className="font-body">Redirecting to sign in...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center mb-4">
            <Icon name="Wrench" size={48} color="var(--color-primary)" />
          </div>
          <h1 className="font-headline font-bold text-3xl md:text-4xl text-foreground mb-2">
            Reset Password
          </h1>
          <p className="font-body text-muted-foreground">
            Enter your new password below
          </p>
        </div>

        <div className="bg-card rounded-lg shadow-sm border border-border p-6 md:p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <Input
              label="New Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e?.target?.value)}
              placeholder="At least 6 characters"
              required
            />

            <Input
              label="Confirm New Password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e?.target?.value)}
              placeholder="Re-enter password"
              required
            />

            {error && (
              <div className="bg-error/10 border border-error text-error rounded-lg p-3 text-sm">
                {error}
              </div>
            )}

            <Button
              type="submit"
              variant="default"
              size="lg"
              loading={loading}
              className="w-full"
            >
              {loading ? 'Updating...' : 'Update Password'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/signin" className="font-body text-sm text-primary hover:underline">
              Back to Sign In
            </Link>
          </div>
        </div>

        <div className="mt-6 text-center">
          <Link to="/" className="font-body text-sm text-primary hover:underline">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;